import React from "react";
import {
  createStackNavigator,
  CardStyleInterpolators,
} from "@react-navigation/stack";

import colors from "../config/colors";
import MigrateScreen from "../screens/MigrateScreen";
import FinalScreen from "../screens/FinalScreen";
import EnterDetailsScreen from "../screens/EnterDetailsScreen";
import PaymentScreen from "../screens/PaymentScreen";
import InfoWebScreen from "../screens/InfoWebScreen";
import RecommendScreen from "../screens/RecommendScreen";
import HomeScreen from "../screens/HomeScreen";
import Submissions from "../screens/Submissions";
import Header from "../components/Header";
import HeaderRightButton from "../components/HeaderRightButton";
import EditProfileScreen from "../screens/EditProfileScreen";
import { Dimensions } from "react-native";

const Stack = createStackNavigator();

const AppNavigator = ({ token }) => {
  return (
    <Stack.Navigator
      initialRouteName="Home"
      screenOptions={{
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    >
      <Stack.Screen
        name="Home"
        component={HomeScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerStyle: {
              backgroundColor: colors.white,
              // width: 0.3 * Dimensions.get("window").width,
            },
            headerTitleAlign: "left",
            headerTintColor: colors.primary,
          };
        }}
      />
      <Stack.Screen
        name="Migrate"
        component={MigrateScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerTitleAlign: "left",
            headerStyle: {
              backgroundColor: colors.white,
              // width: 0.3 * Dimensions.get("window").width,
            },
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />
      <Stack.Screen
        name="Entries"
        component={Submissions}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerTitleAlign: "left",
            headerStyle: {
              backgroundColor: colors.white,
            },
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />

      {/* </> */}
      {/* ) : ( */}
      <Stack.Screen
        name="Edit"
        component={EditProfileScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerStyle: {
              backgroundColor: colors.white,
            },
            headerTitleAlign: "left",
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />
      <Stack.Screen
        name="Info"
        component={InfoWebScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerStyle: {
              backgroundColor: colors.white,
            },
            headerTitleAlign: "left",
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />
      <Stack.Screen
        name="Payment"
        component={PaymentScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerStyle: {
              backgroundColor: colors.white,
            },
            headerTitleAlign: "left",
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />
      <Stack.Screen
        name="Details"
        component={EnterDetailsScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerStyle: {
              backgroundColor: colors.white,
            },
            headerTitleAlign: "left",
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />
      {/* <Stack.Screen name="Qualification" component={QualificationScreen} />
      <Stack.Screen name="ProjectLocation" component={ProjectLocationScreen} />
      <Stack.Screen name="Innovation" component={InnovationScreen} />
      <Stack.Screen name="BusinessQualify" component={BusinessQualifyScreen} />
      <Stack.Screen name="Subsidies" component={SubsidiesScreen} />
      <Stack.Screen
        name="EmploymentCreation"
        component={BusinessEmployScreen}
      />
      <Stack.Screen
        name="BusinessExperience"
        component={BusinessExperienceScreen}
      />
      <Stack.Screen name="BusinessFunding" component={BusinessFundingScreen} />
      <Stack.Screen name="Investment" component={InvestmentScreen} />
      <Stack.Screen name="Business" component={BusinessScreen} />
      <Stack.Screen name="Experience" component={ExperienceScreen} />
      <Stack.Screen name="Age" component={AgeScreen} />
      <Stack.Screen name="College" component={CollegeScreen} />
      <Stack.Screen name="Employment" component={EmploymentScreen} />
      <Stack.Screen name="Languages" component={LanguageScreen} />
      <Stack.Screen name="Funds" component={FundsScreen} />
      <Stack.Screen name="Marital" component={MaritalScreen} />
      <Stack.Screen name="Internship" component={InternshipScreen} /> */}
      <Stack.Screen
        name="Final"
        component={FinalScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerStyle: {
              backgroundColor: colors.white,
            },
            // headerTitleAlign: "left",
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />
      <Stack.Screen
        name="Recommendations"
        component={RecommendScreen}
        options={({ navigation }) => {
          return {
            headerTitle: () => (
              <Header navigation={navigation} title="BLUE CARD VISA" />
            ),
            headerTitleAlign: "left",
            headerStyle: {
              backgroundColor: colors.white,
            },
            headerTintColor: colors.primary,
            headerRight: () => (
              <HeaderRightButton onPress={() => navigation.navigate("Home")} />
            ),
          };
        }}
      />
      {/* <Stack.Screen
        name="My Jobs"
        component={MyJobsNavigator}
        initialParams={{ userType: "customer" }}
      /> */}
      {/* )} */}
    </Stack.Navigator>
  );
};

export default AppNavigator;
